import React from "react";

import type { JSX } from "react";

interface LiveMediaIconProps {
  className?: string;
  height?: number;
  width?: number;
}

function LiveMediaIcon({
  className,
  height = 40,
  width = 40,
}: LiveMediaIconProps): JSX.Element {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 4A3.25 3.25 0 0 1 8 .75h16c.121 0 .238.048.323.134l10.793 10.793a.457.457 0 0 1 .134.323v24A3.25 3.25 0 0 1 32 39.25H8A3.25 3.25 0 0 1 4.75 36V4Z"
        fill="var(--card)"
        stroke="var(--border-strong)"
        strokeWidth={1.5}
      />
      <path
        d="M24 .5V8a4 4 0 0 0 4 4h7.5"
        stroke="var(--border-strong)"
        strokeWidth={1.5}
      />
      <path
        d="M23.182 19.319a4.5 4.5 0 0 1 0 6.364m-6.364 0a4.5 4.5 0 0 1 0-6.364m-2.121 8.485a7.5 7.5 0 0 1 0-10.607m10.607 0a7.5 7.5 0 0 1 0 10.607M20 24a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0v6.75"
        stroke="red"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
export default LiveMediaIcon;
